import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface PermissionCardActionsProps {
  onEdit: () => void;
  onView: () => void;
  onDelete: () => void;
  onToggleStatus: () => void;
  isActive: boolean;
}

const PermissionCardActions: React.FC<PermissionCardActionsProps> = ({
  onEdit,
  onView,
  onDelete,
  onToggleStatus,
  isActive,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAndClose = (action: () => void) => {
    action();
    handleClose();
  };

  return (
    <Box
      sx={{
        marginLeft: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        paddingRight: '16px',
        paddingTop: '8px',
      }}
    >
      <Button
        variant='outlined'
        endIcon={<ArrowDropDownIcon />}
        sx={{
          color: '#0048B6',
          border: '1px solid #0048B6',
          fontSize: '15px',
        }}
        onClick={handleClick}
      >
        Ações
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={() => handleAndClose(onView)} sx={{ fontSize: '15px' }}>
          Visualizar
        </MenuItem>
        <MenuItem onClick={() => handleAndClose(onEdit)} sx={{ fontSize: '15px' }}>
          Editar
        </MenuItem>
        <MenuItem onClick={() => handleAndClose(onDelete)} sx={{ fontSize: '15px' }}>
          Excluir
        </MenuItem>
        <MenuItem onClick={() => handleAndClose(onToggleStatus)} sx={{ fontSize: '15px' }}>
          {isActive ? 'Desativar' : 'Ativar'}
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default PermissionCardActions;
